export default function FlexiblePayment({ size = 64, color = 'white' }) {
  return (
    <svg width={size} height={size} viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M16.88 9.94H47.12C49.5058 9.94 51.44 11.8742 51.44 14.26V21.82H12.56V14.26C12.56 11.8742 14.4942 9.94 16.88 9.94Z"
        stroke={color}
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M19.04 15.88H32"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.24 23.98C8.24 21.5942 10.1742 19.66 12.56 19.66H51.44C53.8258 19.66 55.76 21.5942 55.76 23.98V45.58C55.76 49.1588 52.8588 52.06 49.28 52.06H14.72C11.1412 52.06 8.24 49.1588 8.24 45.58V23.98Z"
        stroke={color}
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M8.24 32.62H55.76"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M32 37.48C34.6863 37.48 36.86 35.3063 36.86 32.62C36.86 29.9337 34.6863 27.76 32 27.76C29.3137 27.76 27.14 29.9337 27.14 32.62C27.14 35.3063 29.3137 37.48 32 37.48Z"
        stroke={color}
        strokeWidth="2"
        strokeLinejoin="round"
      />
    </svg>
  );
}
